export default "__VITE_ASSET__xgoj$YF5__"